import React from "react";
import arrowImage from "../../assets/down-arrow.png";

const Hero = (props) => {
  return (
    <section id="hero" className="d-flex flex-column justify-content-center">
      <div className="container" data-aos="zoom-in" data-aos-delay={100}>
        <h1>Kunal Karnik</h1>
        <p>
          Software Professional | Fullstack Mobile App and Web Developer
          <span
            className="typed"
            data-typed-items="Software Engineer, Fullstack Developer, Freelancer"
          />
        </p>
        <h5>
          <strong>Tech Stack:</strong> React, React Native, Next.js, HTML5,
          CSS3, JavaScript, TypeScript, Node.js, Express.js, MySQL, Python,
          Kotlin, Swift.
        </h5>
        <div className="social-links">
          <a
            target="_blank"
            rel="noreferrer"
            href="https://www.facebook.com/kunal.karnik89/"
            className="facebook"
          >
            <i className="bx bxl-facebook" />
          </a>
          <a
            target="_blank"
            rel="noreferrer"
            href="https://www.instagram.com/kunal.karnik89/"
            className="instagram"
          >
            <i className="bx bxl-instagram" />
          </a>
          <a
            target="_blank"
            rel="noreferrer"
            href="https://www.linkedin.com/in/kunal-karnik-a709b045/"
            className="linkedin"
          >
            <i className="bx bxl-linkedin" />
          </a>
          <a
            target="_blank"
            rel="noreferrer"
            href="https://github.com/Kunal-Karnik"
            className="github"
          >
            <i className="bx bxl-github" />
          </a>
        </div>
      </div>
      <div className="hero-scrollDown">
        <p>Scroll </p>
        <img src={arrowImage} alt="ScrollDown Arrow" />
      </div>
    </section>
  );
};

export default Hero;
